
interface MessageTimestampProps {
  timestamp: Date;
  isUser?: boolean;
}

export function MessageTimestamp({ timestamp, isUser = false }: MessageTimestampProps) {
  return (
    <div className={`text-xs text-muted-foreground mt-2 opacity-70 ${isUser ? 'text-right' : ''}`}>
      {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
    </div>
  );
}
